import { render, staticRenderFns } from "./therapyDetails.vue?vue&type=template&id=85411d6c&scoped=true&"
import script from "./therapyDetails.vue?vue&type=script&lang=js&"
export * from "./therapyDetails.vue?vue&type=script&lang=js&"
import style0 from "./therapyDetails.vue?vue&type=style&index=0&id=85411d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85411d6c",
  null
  
)

export default component.exports